export default {
      id: "video-stop-usage",
      viewBox: "0 0 7 12",
      url: __webpack_public_path__ + "img/icons.svg#video-stop",
      toString: function () {
        return this.url;
      }
    }